module.exports = __webpack_public_path__ + "static/media/40_A.70c8a22f.png";